// Import dependencies
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// import people from '../../assets/people.png';

// Import components

// Import CSS & assets
import './Header.css';
import building from '../../../assets/building_big.png';

const Header_Promoteur = ({ origin, setToggleFullSizeGeneral, setContactGlowing }) => {

    // Set global functions
    const navigate = useNavigate();

    const handleSignUp = () => {
        setToggleFullSizeGeneral(true);
        setTimeout(() => {
            navigate('/auth?type=signup' + (origin !== null ? '&origin=' + origin : ''));
        }, 1200);
    }

    const handleContact = () => {
        document.getElementById('contact').scrollIntoView();
        // document.getElementById('message').value = "Bonjour,\nJe souhaiterais planifier une démonstration de votre solution.";
        // setContactGlowing(1200);
    }

    return (
        <div className="landing__header" id="home">
            <div className="landing__header_background_image">
                <img src={building} alt='building' />
            </div>
            <div className="landing__header_body" style={{ top: '25%' }}>
                <div className="landing__header_subbody">
                    <div className="landing__header_body_partleft">
                        <h1 className="gradient__text landing__header_body_title">Analysez le potentiel d’un terrain en quelques minutes.</h1>
                        <p className="landing__headline">Proplab automatise vos études capacitaires et vous fournit une vision claire du contexte et du potentiel constructible, rapidement, sans effort.</p>
                        <div className="landing__header_body_cta">
                            {/* <button className="landing__header_body_cta_button_main" type="button" onClick={handleSignUp}>S'inscrire gratuitement</button> */}
                            <button className="landing__header_body_cta_button_main" type="button" onClick={handleContact}>Demander un essai gratuit</button>
                            <button className="landing__header_body_cta_button_second" type="button" onClick={handleContact}>Demander une démonstration</button>
                        </div>
                    </div>
                    <div className="landing__header_body_partright"></div>
                </div>
            </div>
            {/* <div className='landing__header_scroll'></div> */}

        </div>
    )
};

export default Header_Promoteur;
